interface HeaderTextProps {
  text?: string;
  secondaryText?: string;
}

const HeaderText = ({ text, secondaryText }: HeaderTextProps) => (
  <div
    style={{
      whiteSpace: "pre-line",
      lineHeight: "19px",
      fontSize: "12px",
      fontWeight: 500,
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      overflow: "hidden",
    }}
  >
    <div>{text}</div>
    {secondaryText && <div>{secondaryText}</div>}
  </div>
);

export default HeaderText;
